/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Contact_Hotline2Inputs */

const vi_shop_contact_hotline2 = /** @type {(inputs: Shop_Contact_Hotline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotline phụ`)
};

/**

* @param {Shop_Contact_Hotline2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_contact_hotline2 = /** @type {((inputs?: Shop_Contact_Hotline2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Contact_Hotline2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_contact_hotline2(inputs)
});